// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"cd6fda52","43":"3727b762","50":"b6f6739d","98":"2b27220d","376":"4ab18ad5","864":"fa0e2aec","892":"72b8f9bc","934":"6ce243a7","950":"1b04c948"}[chunkId] + ".chunk.js";
};